import * as types from 'constants/ActionTypes';
import { Map, fromJS } from 'immutable';

const defaultPayment = Map({
  lastUpdated: null,
  loaded: false,
  stripeSubmitting: false,
  cardErrorOccured: false,
  loadingOTP: false,
  showOTPModal: false,
  otpConfirmed: false,
  otpTriggerPayment: false,
  pointsUsed: 0,
  otpError: '',
  otpErrorCode: false,
  // ReedemFlow
  showRedeemModal: false,
  nitCodeGenerated: false,
  nitCodeValidated: false,
  threeDSRetryTriggered: false,
  threeDSRetryAttempted: false,
});

/**
 * Payment reducer.
 * Manages payment state including loading states, errors, OTP flow, and redeem flow.
 *
 * @param {Map} payment - Current payment state.
 * @param {Object} action - Redux action object.
 * @returns {Map} Updated payment state.
 */
export default function payment(payment = defaultPayment, action) {
  switch (action.type) {
    case types.RESET_PAYMENT_CARD_ERROR:
      return payment.set('cardErrorOccured', false);

    case types.RESET_PAYMENT:
      return defaultPayment;

    case types.REQUEST_PAYMENT:
      return payment.set('isFetching', true);

    case types.SET_STRIPE_SUBMITTING:
      return payment.set('stripeSubmitting', action.submitting);

    case types.RECEIVE_PAYMENT: {
      const isolatedBasisTheoryReceipt =
        action.payload?.cardCheckoutMode === 'basis_theory' &&
        action.payload?.paymentEngine === 'mercadopago' &&
        action.payload?.paymentType === 'credit_card';
      const receiptPayment = isolatedBasisTheoryReceipt
        ? payment.delete('threeDsChallenge').delete('mercadopagoThreeDsInfo').delete('redirectTo')
        : payment;
      return receiptPayment.merge(
        fromJS({
          isFetching: false,
          loaded: true,
          ...action.payload,
        }),
      );
    }

    case types.SET_CARD_ERROR_OCCURED:
      return payment.set('cardErrorOccured', true);

    case types.LOADING_OTP:
      return payment
        .set('loadingOTP', action.payload.loading)
        .set('showOTPModal', action.payload.showOTPModal)
        .set('otpError', false)
        .set('otpErrorCode', false);

    case types.OTP_CREATION:
      return payment
        .set('loadingOTP', false)
        .set('showOTPModal', action.payload.showOTPModal)
        .set('otpConfirmed', false);

    case types.OTP_CONFIRMATION:
      return payment
        .set('loadingOTP', false)
        .set('showOTPModal', action.payload.showOTPModal)
        .set('otpConfirmed', action.payload.otpConfirmed)
        .set('otpTriggerPayment', action.payload.otpConfirmed);

    case types.OTP_ERROR:
      return payment
        .set('otpError', action.payload.otpError)
        .set('otpErrorCode', action.payload.otpErrorCode);

    case types.OTP_CLEAR:
      return payment.set('otpError', false).set('otpErrorCode', false).set('showOTPModal', false);

    case types.REDEEM_MODAL_TOGGLE:
      return payment.set('showRedeemModal', action.payload);

    case types.SET_NIT_CODE_GENERATED:
      return payment.set('nitCodeGenerated', true);

    case types.SET_NIT_CODE_VALIDATED:
      return payment.set('nitCodeValidated', true);

    case types.TRIGGER_3DS_RETRY:
      return payment
        .set('threeDSRetryTriggered', true)
        .set('threeDSRetryAttempted', true)
        .set('threeDSRetryAmount', action.amount || 0);

    case types.RESET_3DS_RETRY:
      return payment.set('threeDSRetryTriggered', false);

    default:
      return payment;
  }
}
